import axios from "axios";
import createQuery from "helpers/create-query";
import settings from "utils/settings";

const { apiUrl } = settings;

export const requestMerchandiserGetCharges = (options) => {
    const defaultOptions = {
        // employeeId,
        // jobId,
        status: "AllCharges",
        // fromDate,
        // toDate
    };
    const query = createQuery(defaultOptions, options);
    return axios.get(`${apiUrl}merchandiserInvoicing/charges?${query}`);
};

export const requestMerchandiserGetJobs = () =>
    axios.get(`${apiUrl}merchandiserInvoicing/jobs`);

export const requestMerchandiserRecentJobs = () =>
    axios.get(`${apiUrl}jobs/recent`);

export const requestRecentCompletedServices = (merchandiserId, chargeId) => {
    let query = merchandiserId ? `?merchandiserId=${merchandiserId}` : "";
    if (query) {
        query += chargeId ? `&chargeId=${chargeId}` : "";
    }
    else {
        query = chargeId ? `?chargeId=${chargeId}` : "";
    }
    return axios.get(`${apiUrl}completedServices/recent${query}`);
};

export const requestMerchandiserGetInvoices = (options) => {
    const defaultOptions = {
        // jobId,
        // merchandiserId,
        // fromDate,
        // toDate
    };
    const query = createQuery(defaultOptions, options);
    return axios.get(`${apiUrl}merchandiserInvoicing/invoices?${query}`);
};

export const requestMerchandiserGetInvoiceByIdForPDF = (invoiceId) =>
    axios.get(`${apiUrl}merchandiserInvoicing/invoices/${invoiceId}`, {
        responseType: "blob"
    });

export const requestMerchandiserGetPdfInvoice = (options) => {
    const defaultOptions = {
        // jobId,
        // merchandiserId,
        // fromDate,
        // toDate
    };
    const query = createQuery(defaultOptions, options);
    return axios.get(`${apiUrl}merchandiserInvoicing/preliminary?${query}`, {
        responseType: "blob"
    });
};

export const requestMerchandiserApproveGroup = (data) =>
    axios.post(`${apiUrl}merchandiserInvoicing/charges/approve`, data);

export const requestSubmitMerchandiserInvoice = (data) =>
    axios.post(`${apiUrl}merchandiserInvoicing/invoices`, data);

export const requestGetMerchandiserChargeById = (chargeId) =>
    axios.get(`${apiUrl}merchandiserInvoicing/charges/${chargeId}`);

export const requestMerchandiserupdateMerchandiserCharge = (chargeId, data) =>
    axios.patch(`${apiUrl}merchandiserInvoicing/charges/${chargeId}`, data);

export const requestCustomerInvoicingCharges = (options) => {
    const defaultOptions = {
        // supplierId,
        // jobId,
        // fromDate,
        // toDate
    };
    const query = createQuery(defaultOptions, options);
    return axios.get(`${apiUrl}customerInvoicing/charges?${query}`);
};

export const requestPatchCustomerChargeBillingHours = (invoiceSummaryId, billableHours) =>
    axios.patch(`${apiUrl}customerInvoicing/charges/${invoiceSummaryId}/billableHours`, {
        billableHours
    });

export const requestCustomerInvoicingInvoices = (options) => {
    const query = createQuery({}, options);
    return axios.get(`${apiUrl}customerInvoicing/invoices?${query}`);
};

export const requestCustomerInvoicingGetInvoiceById = (invoiceId) =>
    axios.get(`${apiUrl}customerInvoicing/invoices/${invoiceId}`);

export const requestCustomerInvoicingUpdateInvoiceById = (invoiceId, data) =>
    axios.put(`${apiUrl}customerInvoicing/invoices/${invoiceId}`, data);

export const requestCustomerInvoicingDeleteInvoice = (invoiceId) =>
    axios.delete(`${apiUrl}customerInvoicing/invoices/${invoiceId}`);

export const requestCustomerGetPdfInvoice =
    (invoiceId) => axios.get(`${apiUrl}customerInvoicing/invoices/${invoiceId}/pdf`, {
        responseType: "blob"
    });

export const requestCustomerGetPdfSummary =
    (invoiceId) => axios.get(`${apiUrl}customerInvoicing/invoices/${invoiceId}/summary`, {
        responseType: "blob"
    });

export const requestCustomerGetCsvSummary =
    (invoiceId) => axios.get(`${apiUrl}customerInvoicing/invoices/${invoiceId}/summary/csv`, {
        responseType: "blob"
    });

export const requestCustomerGetExcelSummary =
    (invoiceId) => axios.get(`${apiUrl}customerInvoicing/invoices/${invoiceId}/summary/excel`, {
        responseType: "blob"
    });

export const requestCustomerSendInvoice = (invoiceId) =>
    axios.post(`${apiUrl}customerInvoicing/invoices/${invoiceId}/send`);

export const requestCustomerSubmitInvoice = (invoiceId) =>
    axios.post(`${apiUrl}customerInvoicing/invoices/${invoiceId}/submit`);


export const requestCustomerGenerateInvoice = (data) =>
    axios.post(`${apiUrl}customerInvoicing/invoices`, data);

export const requestCustomerExportChargesExcel = (data) =>
    axios.post(`${apiUrl}customerInvoicing/charges/export/excel`, data, {
        responseType: "blob"
    });
export const requestGetAccountingServiceInvoices = (batchNumber) =>
    axios.get(`${apiUrl}accountingExport/serviceInvoices?batchNumber=${batchNumber}`);

export const requestGetAccountingServiceInvoicesBatches = () =>
    axios.get(`${apiUrl}accountingExport/serviceInvoices/batches`);

export const requestGetAccountingClientInvoicesBatches = () =>
    axios.get(`${apiUrl}accountingExport/clientInvoices/batches`);

export const requestExportAccountingServiceInvoices = (data) =>
    axios.post(`${apiUrl}accountingExport/serviceInvoices/export`, data);

export const requestGetAccountingClientInvoices = (batchNumber) =>
    axios.get(`${apiUrl}accountingExport/clientInvoices?batchNumber=${batchNumber}`);

export const requestReportExcel = (batchNumber) =>
    axios.post(`${apiUrl}AccountingExport/service/export/excel?batchNumber=${batchNumber}`, {}, {
        responseType: "blob"
    });

export const requestClientReportExcel = (batchNumber) =>
		axios.post(`${apiUrl}AccountingExport/client/export/excel?batchNumber=${batchNumber}`, {}, {
				responseType: "blob"
		});

export const requestExportAccountingClientInvoices = (data) =>
    axios.post(`${apiUrl}accountingExport/clientInvoices/export`, data);

export const requestExportAccountingActiveJobs = () =>
    axios.post(`${apiUrl}accountingExport/activeJobs/export`);

export const requestGetMissingMerchandiserCharges = (fromDate) => {
    const queryParam = fromDate ? `?fromDate=${fromDate}` : "";

    return axios.get(`${apiUrl}missingCharges/merchandiser${queryParam}`);
};

export const requestCreateMerchandiserCharges = (data) =>
    axios.post(`${apiUrl}missingCharges/merchandiser`, data);

export const requestGetMissingClientCharges = (fromDate) => {
    const queryParam = fromDate ? `?fromDate=${fromDate}` : "";

    return axios.get(`${apiUrl}missingCharges/client${queryParam}`);
};

export const requestCreateClientCharges = (data) =>
    axios.post(`${apiUrl}missingCharges/client`, data);

export const requestProcessAutoTravelCharges = (date) =>
    axios.post(`${apiUrl}AutoTravelCharges/process/${date}`);